import { SessionStorageService } from './session-storage';

const KEY_NAME = 'session-id';

const userSessionSessionStorageService = new SessionStorageService(KEY_NAME);

export { userSessionSessionStorageService };
